// src/constants/roles.js
//
// Roles are dynamic — a role is a role-scoped PermissionSet created from any
// <RoleSelect allowCreate> (see services/rolesApi.js). So "who may see every
// branch" can NOT be a hardcoded name list any more: a role minted today would
// never be in it.
//
// Global visibility is therefore read off the role itself — the max data scope
// bound to the user's role set in the Dashboard Builder, returned on login as
// user.dashboard.maxScope. The name list below is kept only as a fallback for
// sessions stored before that field existed and for the seeded system roles.

// Legacy fallback only. Do not add to this list — set the role's max data scope
// to GLOBAL in the Dashboard Builder instead.
export const GLOBAL_VIEWER_ROLES = ['ADMIN', 'CEO', 'HO_MANAGER'];

// True when the user's role may look across every branch (Head Office view).
export const isGlobalViewer = (user) => {
  if (!user) return false;
  if (String(user.dashboard?.maxScope || '').toUpperCase() === 'GLOBAL') return true;
  return GLOBAL_VIEWER_ROLES.includes(String(user.role || '').toUpperCase());
};
